import React, { useEffect } from 'react';
import { useState, useContext } from 'react';
import { useGlobalState } from '../../contexts/GlobalState';

const Preload = React.createContext();

const noOfFrames = 501;

function PreloadProvider({ children }) {
    const { screenOrientation } = useGlobalState();
    const [preloaded, setPreloaded] = useState(false);

    const getIndexString = (index) => {
        let index_string = '';
        if (index < 10) {
            index_string = `00${index}`;
        } else if (index < 100) {
            index_string = `0${index}`;
        } else {
            index_string = `${index}`;
        }

        return index_string;
    };

    useEffect(() => {
        const preloadedArr = [...Array(noOfFrames)];

        function checkPreloaded() {
            let i = 1;
            let numPreloaded = 0;

            while (i <= noOfFrames) {
                if (preloadedArr[i]) {
                    numPreloaded++;
                }
                i++;
            }

            if (numPreloaded > noOfFrames * 0.6) {
                console.log(
                    'enough preloaded',
                    numPreloaded + ' of ' + noOfFrames
                );
                setPreloaded(true);
            } else {
                // console.log('NOT LOADED', preloadedArr);
                setTimeout(checkPreloaded, 300);
            }
        }

        // defer for 2 second to start fetching the panorama and other critical assets
        // only then start fetching these
        setTimeout(() => {
            for (let i = 1; i <= noOfFrames; i++) {
                const index_string = getIndexString(i);
                let src = `${window.rootUrl}/img/splotch/${screenOrientation}/video_${index_string}.webp`;
                let img = new Image();
                img.src = src;
                img.onload = () => {
                    preloadedArr[i] = true;
                };
            }

            checkPreloaded();
        }, 2000);
    }, [screenOrientation]);

    return (
        <Preload.Provider
            value={{
                preloaded,
                noOfFrames,
            }}
        >
            {children}
        </Preload.Provider>
    );
}

const usePreload = () => {
    return useContext(Preload);
};

export { PreloadProvider, usePreload };
